import { Table } from '@chakra-ui/react'
import styled from 'styled-components'

const ScrollableTable = styled(Table)`
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  tbody {
    display: block;
    height: 400px;
    overflow-y: auto;
    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }
  }
`

export default ScrollableTable
